export default __webpack_public_path__ + "img/player-count-many.3de52b4b.svg";